<template>
  <NvxScrollableScaffold class="layout-sct2">
    <template #content>
      <slot />
    </template>
    <template #buttons>
      <SCT2Footer />
    </template>
  </NvxScrollableScaffold>
</template>

<script>
import SCT2Footer from '@/components/layout/SCT2Footer.vue'
import NvxScrollableScaffold from '@/components/ui/NvxScrollableScaffold.vue'

export default {
  name: 'LayoutSCT2',
  components: {
    SCT2Footer,
    NvxScrollableScaffold,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

.layout-sct2 {
  height: 100%;
  background-color: var(--color-background);
}

@media (prefers-color-scheme: dark) {
  .layout-sct2 {
    background-color: var(--color-background-dark);
  }
}
</style>
